module.exports = __webpack_public_path__ + "img/small-2.d7ae519f.webp";